<script>
  import { ci } from "../store";

  export let content;
  export let color;

  const font = $ci.page.heading.font ? `--font: ${$ci.page.heading.font};` : "";
  const fontWeight = $ci.page.heading.font_weight
    ? `--fontWeight: ${$ci.page.heading.font_weight};`
    : "";
  const fontStyle = $ci.page.heading.font_style
    ? `--fontStyle: ${$ci.page.heading.font_style};`
    : "";

  const size = $ci.page.heading.font ? `--size: ${$ci.page.heading.size};` : "";

  const fontColor = color ? `--color: ${color};` : "";

  const lineHeight = $ci.page.heading.line_height
    ? `--lineHeight: ${$ci.page.heading.line_height};`
    : "";

  const style = `${font}${size}${fontWeight}${fontStyle}${fontColor}${lineHeight}`;
</script>

<h2 {style}>{content}</h2>

<style>
  h2 {
    font-family: var(--font);
    font-size: var(--size);
    font-weight: var(--fontWeight);
    font-style: var(--fontStyle);
    color: var(--color);
    line-height: var(--lineHeight);
    margin: 0.33rem 0;
    text-align: center;
  }
</style>
